export const MEMBERSHIP_TYPES_FOR_TRACKING = {
    MEMBERTYPEBOTH: { name: "Fagforening + A-kasse", id: 3 },
    MEMBERTYPEUNION: { name: "Fagforening", id: 1 },
    MEMBERTYPEUNIMPLOYMENTINSURANCEFUND: { name: "A-kasse", id: 2 },
};

export const PAYMENT_METHODS_TRANSLATED = {
    PAYMENT_METHOD_CARD: "Kort",
    PAYMENT_METHOD_MOBILEPAY: "Mobilepay",
    PAYMENT_METHOD_BETALINGSSERVICE: "Betalingsservice",
};

export const VARIANTS = {
    VARIANT_STUDERENDE: "Studerende",
    VARIANT_ERHVERVSAKTIV: "Erhvervsaktiv",
};

export const OCCUPATIONS_TRANSLATED = {
    EMPLOYED: "I arbejde",
    UNEMPLOYED: "Ledig",
    SELF_EMPLOYED: "Selvstændig",
    VOCATIONAL_EDUCATION: "Praktisk uddannelse",
    STUDENT: "Studerende",
    TRAINEE: "Trainee",
};

export const ITEM_QUANTITY = 1;
export const CURRENCY = "DKK";

export const EVENTS = {
    TRACK_STEP: "indmeldelse_step",
    VIRTUAL_PAGE_VIEW: "trackPageview",
    EXIT_CLICKS: "afbryd_indmeldelse",
    PROGRESSION_BAR_CLICKED: "progress_bar_click",
    CHOSEN_MEMBERSITUATION: "valgt_situation",
    MEMBER_SITUATION_OTHER_FLOW_CLICKED: "indmeldelse_kliks",
    BACK_BUTTON_CLICKED: "indmeldelse_kliks",
    TYPE_AHEAD_OTHER_CLICKED: "søgeboks",
    TYPE_AHEAD_OTHER_FAIL: "søgebokse",
    CHOSEN_INCOME_LEVEL: "valgt_indkomstniveau",
    CHOSEN_SALARY_INSURANCE: "valgt_lønforsikring",
    REGISTRATION_CANT_CONTINUE: "indmeldelse_kan_ikke_forsætte",
    MEMBERSHIP_TYPE_INFO_ICON_CLICKED: "indmeldelse_kliks",
    MEMBERSHIP_BENEFITS_MOBILE_CLICKED: "indmeldelse_kliks",
    MEMBERSHIP_STARTING_DATE_CHANGED: "startdato_ændring",
    CONTACT_HK: "indmeldelse_kliks",
    ADD_MEMBERSHIP_TO_CART: "add_to_cart",
    ADD_PAYMENT_INFO: "add_payment_info",
    MEMBER_REGISTRATION_COMPLETED: "purchase",
    FRONT_PAGE_SITUATION_CLICK: "bliv_medlem_kliks",
    FRONT_PAGE_INCOME_CLICK: "bliv_medlem_kliks",
    FRONT_PAGE_ALL_BENEFITS_CLICK: "bliv_medlem_kliks",
    FRONT_PAGE_BECOME_MEMBER_BENEATH_MEMBERSHIP_TYPES_CLICK: "cta_kliks",
    FRONT_PAGE_CTA_LINE_CLICK: "cta_kliks",
    FRONT_PAGE_SALARY_INSURANCE_FUND_CTA_CLICK: "cta_kliks",
    FRONT_PAGE_SALARY_INSURANCE_FUND_MORE_INFO_CLICK: "akasse_kliks",
    FRONT_PAGE_SALARY_INSURANCE_FUND_BECOME_MEMBER_CLICK: "cta_kliks",
    FRONT_PAGE_SALARY_INSURANCE_FUND_SALARY_INSURANCE_INFO_CLICK:
        "akasse_kliks",
    FRONT_PAGE_SALARY_INSURANCE_FUND_UNION_INFO_CLICK: "akasse_kliks",
    TARGET_GROUP_PAGE_BECOME_MEMBER_CLICK: "cta_kliks",
    FAQ_QUESTION_CLICK: "faq_expand",
};

export const CLICK_TYPES = {
    BACK: "Navigation",
};

export const CLICK_TEXT = {
    BACK: "Tilbage",
    EXIT: "Kryds i flow",
    PROGRESS_BAR_INITIAL: "Åben drop down",
    INFO_ICON: "Infoikon",
    MEMBER_BENEFITS_MOBILE: "Vis medlemsfordele",
};

export const RESULTS = {
    SEARCH_FIELD: "Andet",
    SEARCH_FIELD_ERROR: "Error",
};

export const INCOME_LEVEL = {
    MORE_THAN_27K: "Mere end 28.200 kr.",
    LESS_THAN_27K: "Mindre end 28.200 kr.",
};

export const MEMBER_SITUATIONS_TRANSLATED = {
    EMPLOYED: "Lønmodtager",
    STUDENT: "Studerende / Elev",
    UNEMPLOYED: "Ledig",
    SELF_EMPLOYED: "Selvstændig",
    TRAINEE: "Trainee",
    VOCATIONAL_EDUCATION: "Elev",
};

export const SALARY_INSURANCE_CHOICES = {
    HAS_SALARY_INSURANCE: "Jeg har en lønforsikring",
    NO_SALARY_INSURANCE: "Jeg har ikke en lønforsikring",
    NOT_SURE: "Ved ikke",
};
